<template>
  <div>
    <DataOwner></DataOwner>
  </div>
</template>

<script>

import DataOwner from '../components/DataOwner.vue';

export default {
  components: {
    DataOwner,
  },
};
</script>
